import { State } from 'src/types'
import { web, webTop } from '../web'
import { webTop0, webTop1, webTop2, webTop3 } from '../lace/web'
import { webToIndexFinger, webToThumbFinger } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/lace/connectWeb'
import { webKnots } from 'src/features/gorilla/drawer/common/back/lace/webKnots'
import { laceOfWebTopToIndexFinger, laceOfWebTopToThumbFinger, webToCatchFace } from '../lace/connectWeb'
import { arroundEdge4, arroundEdge5, arroundEdge6 } from '../lace/arroundEdge'
import { webKnotDownward } from 'src/features/gorilla/drawer/common/back/lace/webKnotSingle'

export const deepWeb = (ctx: CanvasRenderingContext2D, state: State): void => {
  laceOfWebTopToIndexFinger(ctx, state.lace.color)
  laceOfWebTopToThumbFinger(ctx, state.lace.color)

  webTop(ctx, state.web.color, state.stitch.color)
  web(ctx, state.web.color, state.stitch.color)

  webTop3(ctx, state.lace.color)
  webTop2(ctx, state.lace.color, 12, 18)
  webTop2(ctx, state.lace.color, 0, 0)
  webTop2(ctx, state.lace.color, -14, -17)
  webTop1(ctx, state.lace.color, 110, -73, 13)
  webTop1(ctx, state.lace.color, 89, -28, 8)
  webTop1(ctx, state.lace.color, 69, -42, 8)
  webTop1(ctx, state.lace.color, 40, 30)
  webTop1(ctx, state.lace.color, 20, 14)
  webTop1(ctx, state.lace.color, 0, 0)
  webTop1(ctx, state.lace.color, -20, -13)
  webTop0(ctx, state.lace.color)
  webToCatchFace(ctx, state.lace.color, 0, 0)
  webToCatchFace(ctx, state.lace.color, 45, 37)
  webToCatchFace(ctx, state.lace.color, 93, 80)
  webToIndexFinger(ctx, state.lace.color)
  webKnots(ctx, state.lace.color, -18, -19)

  // 順番が大事なのでこの中でarroundEdgeも一部描画
  arroundEdge4(ctx, state.lace.color)
  arroundEdge5(ctx, state.lace.color)
  arroundEdge6(ctx, state.lace.color, 5, 0)
  arroundEdge6(ctx, state.lace.color, -5, 0)
  webToThumbFinger(ctx, state.lace.color)

  webKnotDownward(ctx, state.lace.color, -3, -160, 20) //親指袋の隣
  webKnotDownward(ctx, state.lace.color, -480, -630, 70) // 人差し指袋の右隣
}
